import { withInstall } from '@/utils'
import CosStaticSelect from './src/index.vue'
export default withInstall(CosStaticSelect)
